import type {
  CoreUserIdentity,
  CoreUserIdentityResponseSingle,
} from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Get user logged identity by ID.
 *
 * @endpoint GET /api/me/identities/{auth0Id}
 * @scope shared
 * @see https://flecto.dev/api-5836478
 */
export async function getUserIdentityById(auth0Id: string): Promise<CoreUserIdentity> {
  const response = await api.get<CoreUserIdentityResponseSingle>(
    `/api/me/identities/${auth0Id}`
  )

  return response.data.user_identity
}
